import * as Sentry from "@sentry/react-native";
export function addBreadcrumb(crumb: Sentry.Breadcrumb) {
  Sentry.addBreadcrumb(crumb);
}

export function captureException(exception: any, captureContext?: any) {
  Sentry.captureException(exception, captureContext);
}

export function captureMessage(exception: string) {
  Sentry.captureMessage(exception);
}
